import { css } from 'lit'

function slotify(condition, selector) {
    return condition ? css`::slotted(${selector})` : css`${selector}`
}

export function getRowStyle(slotted = false) {
    let row_selector = slotify(slotted, css`[part=row]`)    
    return css`
        ${row_selector} {
            font-size: 11px;
            display: grid;
            grid-template-columns: 30px 30px 150px 150px 30px 1fr 70px 100px 80px 30px;
            grid-template-rows: 25px;
            align-items: stretch;
            padding: 0px;
            width:100%;
            max-width: 100%;
        }

        ${row_selector} > * {
            padding: 5px 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            box-sizing: border-box;
        }

        ${row_selector} .article,
        ${row_selector} .brand,
        ${row_selector} .name {
            padding: 0px;
        }

        ${row_selector} .name {
            cursor: pointer;
        }

        ${row_selector} .name:hover {
            color: red;
        }

        ${row_selector} copy-box {
            padding: 5px 10px;
            width: 100%;
            height: 100%;
        }

        ${row_selector} .img-button {
            max-height: 100%;
            align-self: stretch;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px;
            cursor: pointer;
            box-sizing: border-box;
        }

        ${row_selector} .img-button svg {
            margin: 2px;
        }

        ${row_selector} .img-button.disabled {
            opacity: 0.3;
            pointer-events: none;
        }

        ${row_selector} .img-button img {
            max-height: 100%;
        }

        ${row_selector} .centered {
            text-align: center;
        }

        ${slotify(slotted, css`[part=row].table-header`)},
        ${slotify(slotted, css`[part=row].cart-header`)} {
            position: sticky;
            top: 0;
            z-index: 1;
            background: linear-gradient(180deg, #FFFFFF 0%, #E2E2E2 17.71%, #FFFFFF 66.67%, #DADCDD 100%);
        }

        ${row_selector} amount-input {
            padding: 0 !important;
            display: flex;
            width: 100%;
        }

        ${row_selector} amount-input.disabled {
            opacity: 0.3;
            pointer-events: none;
        }
          
        ${row_selector} amount-input button {
            border: solid #0005 1px;
            border-radius: 0px;
            cursor: pointer;
        }

        ${row_selector} amount-input::part(input) {
            font-size: 11px;
            display: inline-flex;
            justify-content: center;
            border-radius: 0px;
            border: solid #0005 1px;
            border-left: none;
            border-right: none;
            text-align: center;
            width: 100%;
        }

        ${row_selector} .price.changed {
            outline: solid red 1px;
            outline-offset: -1px;
            background: #f001;
        }
    `
}

export function getScrollbarStyle() {
    return css`
        *::-webkit-scrollbar {
            height: 5px;
            width: 5px;
        }

        *::-webkit-scrollbar-track {
          border-radius: 5px;
          background-color: #F5F5F5;
        }

        *::-webkit-scrollbar-track:hover {
          background-color: #F5F5F5;
        }

        *::-webkit-scrollbar-track:active {
          background-color: #F5F5F5;
        }

        *::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background-color: #dadada;
        }

        *::-webkit-scrollbar-thumb:hover {
          background-color: #bbbbbb;
        }

        *::-webkit-scrollbar-thumb:active {
          background-color: #bbbbbb;
        }
    `
}


////////////////////////////////////////////////////////////

export const tippyCSS = css`.tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:"";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}`
export const tippyLightCSS = css`.tippy-box[data-theme~=light]{color:#26323d;box-shadow:0 0 20px 4px rgba(154,161,177,.15),0 4px 80px -8px rgba(36,40,47,.25),0 4px 4px -2px rgba(91,94,105,.15);background-color:#fff}.tippy-box[data-theme~=light][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff}.tippy-box[data-theme~=light][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff}.tippy-box[data-theme~=light]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light]>.tippy-svg-arrow{fill:#fff}`
export const tippyAnimationShiftToward = css`.tippy-box[data-animation=shift-toward][data-state=hidden]{opacity:0}.tippy-box[data-animation=shift-toward][data-state=hidden][data-placement^=top]{transform:translateY(-10px)}.tippy-box[data-animation=shift-toward][data-state=hidden][data-placement^=bottom]{transform:translateY(10px)}.tippy-box[data-animation=shift-toward][data-state=hidden][data-placement^=left]{transform:translateX(-10px)}.tippy-box[data-animation=shift-toward][data-state=hidden][data-placement^=right]{transform:translateX(10px)}`
export const tippyAnimationShiftAway = css`.tippy-box[data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=top]{transform:translateY(10px)}.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=bottom]{transform:translateY(-10px)}.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=left]{transform:translateX(10px)}.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=right]{transform:translateX(-10px)}`

////////////////////////////////////////////////////////////

export const tippyLightOverrides = css`
    .tippy-box {
        background: #FFFFFF !important;
        border: 1px solid #C2C1C1 !important;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25) !important;
        padding: 7px !important;
        width: 200px;
    }

    .tippy-box[data-placement^="bottom"] > .tippy-arrow::before {
        top: -8px;                
        width: 10px;
        height: 10px;
        background: white;
        transform: rotate(45deg);
        border: solid #0005 1px;
        border-width: 1px 0px 0px 1px;
    }
`

////////////////////////////////////////////////////////////

export const cardCSS = css`
    .detailed-card {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .info-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px
    }

    .info-box > div {
        display: flex;
        flex-direction: column;
        font-family: 'Roboto';
        font-size: 13px;
        gap: 6px
    }

    .info-box > div > *:first-child {
        font-family: 'Roboto Bold';
    }

    .info-box > .price,
    .info-box > .buy  {
        flex-direction: row;
        align-items: flex-end;
        gap: 13px;
    }

    .info-box > .price > *:first-child {
        font-size: 20px;
    }

    .info-box amount-input {
        width: 100px;
    }

    .info-box amount-input button {
        font-size: 14px;
        border-radius: 5px;
        appearance: none;
        border: none;
        width: 90px;
        max-width: 90px;
        height: 30px;
        max-height: 30px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .info-box amount-input::part(input) {
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .info-box .img-button {
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 0px 10px;
        appearance: none;
        border: none;
        height: 30px;
        background: linear-gradient(93.1deg, #FF0000 15.85%, #890000 93.05%);
        border-radius: 5px;
        color: white;
        cursor: pointer;
    }

    .detailed-card .img-box {
        border: solid #0001 1px;
        margin: 10px;
        align-items: center;
        justify-content: center;
    }

    .detailed-card  .info-box amount-input::part(input):focus {
        outline: solid black 1px;
        outline-offset: -3px;
        border-radius: 4px;
        background: none;
    }

    .detailed-card .img-box img {
        width: 100%;
        max-height: 100%;
    }
`
////////////////////////////////////////////////////////////


export const orderCSS = css`
    .order-preview {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;
        align-self: flex-start;
        font-family: "Roboto";
        font-size: 13px;
        padding: 0px 10px;
        position: relative;
    }

    .order-preview > .title {
        font-family: "Roboto Bold";
        font-size: 16px;
        border-bottom: solid red 2px;
        padding: 10px 0px;
    }

    .order-preview > .assignee {
        border-bottom: solid #0001 1px;
        padding: 10px 0px;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-bottom: 41px;
    }

    .order-preview > .assignee > * {
        display: grid;
        grid-template-columns: 120px 1fr;
        color: #000a;
    }

    .order-preview > .assignee > * > *:last-child {
        font-family: 'Roboto Bold';
    }

    .order-preview > .assignee > *:first-child > *:last-child {
        color: black;
    }

    .order-preview > .items {
        display: flex;
        flex-direction: column;
    }

    .order-preview .item {
        padding: 10px 0px;
        padding-bottom: 20px;
        border-bottom: solid #0001 1px;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .order-preview .item > *:first-child {
        display: grid;
        grid-template-columns: 1fr 50px 100px;
    }

    .order-preview .item > *:last-child {
        display: grid;
        grid-template-columns: 1.5fr 0.5fr;
        font-size: 12px;
    }

    .order-preview .item > *:first-child > *:first-child,
    .order-preview .item > *:first-child > *:last-child {
        font-family: "Roboto Bold";
    }

    .order-preview .item > *:first-child > *:not(:first-child) {
        text-align: right;
    }

    .order-preview .item.error {
        color: red;
    }


    .order-preview .item.user {
        opacity: 0.3;
    }

    .order-preview .errors {
        background: red;
        grid-column: 1 / 3;
        color: white;
        border-radius: 8px;
        margin-top: 10px;
        font-size: 13px;
        text-align: center;
        background: white;
        color: red;
        border: solid #dbdbdb 1px;
        border-radius: 0px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.14);
        font-family: 'Roboto Bold';
        padding: 15px;
    }

    .order-preview .error-message {
        grid-column: 1 / 3;
    }

    .order-preview .bottom-panel {
        position: sticky;
        bottom: 0px;
        background: white;
    }

    .order-preview  .total {
        display: grid;
        grid-template-columns: 1fr 70px 120px;
        font-size: 14px;
        padding: 10px 0px;
        padding-bottom: 20px;
        border-bottom: solid red 2px;
    }

    .order-preview  .total > *:first-child,
    .order-preview  .total > *:last-child {
        font-family: "Roboto Bold";
    }


    .order-preview  .total > *:first-child {
        text-transform: uppercase;
    }

    .order-preview  .total > *:last-child {
        text-align: right;
        color: red;
    }

    .order-preview  .tips {
        color: #0009;
        text-align: right;
        padding-bottom: 15px;
        border-bottom: solid red 2px;
    }

    .order-preview  .checkout {
        display: grid;
        grid-template-columns: 1fr 200px;
        gap: 10px;
        padding: 20px 0px;
        height: 32px;
    }

    .order-preview  .checkout input {
        appearance: none;
        background: rgba(0, 0, 0, 0.04);
        border: none;
        border-radius: 8px;
        padding: 0px 15px;
        transition: 0.3s;
        outline: none;
    }

    .order-preview  .checkout input:focus {
        box-shadow: inset 0px 4px 2px rgba(0, 0, 0, 0.07);
    }

    .order-preview  .checkout button {
        font-family: "Roboto Bold";
        appearance: none;
        background: linear-gradient(90.73deg, #FF0000 6.33%, #BA0202 95.28%);
        border: none;
        border-radius: 8px;
        color: white;
        text-transform: uppercase;
        cursor: pointer;
    }

    .order-preview  .checkout button:hover {
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
`

////////////////////////////////////////////////////////////

export const orderAacceptCSS = css`
    .order-ready {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 300px;
        font-family: "Roboto Medium";
        font-size: 16px;
        color: black
    }

    .order-ready .title {
        padding: 10px 10px;
        border-bottom: solid red 2px;
        padding-bottom: 15px;
        width: 100%;
    }

    .order-ready .title b {
        color: red;
    }

    .order-ready .tips {
        font-size: 12px;
        padding: 20px 10px;
    }

    .order-ready button {
        appearance: none;
        border: none;
        padding: 5px 15px;
        background: #0001;
        font-family: "Roboto Bold";
        border-radius: 5px;
        cursor: pointer;
    }

    .order-ready button:hover {
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25)
    }

`

////////////////////////////////////////////////////////////

export const goodCheckboxCSS = css`
    .control {
        display: block;
        position: relative;
        cursor: pointer;
    }
    .control input {
        z-index: -1;
        opacity: 0;
    }
    .control_indicator {
        position: absolute;
        height: 16px;
        width: 16px;
        background: #fdfbfb;
        border: 1px solid #d4d2d2;
        border-radius: 0px;
        box-sizing: border-box;
    }

    .control:hover input ~ .control_indicator,
    .control input:focus ~ .control_indicator {
        background: #f5f5f5;
    }

    .control input:checked ~ .control_indicator {
        background: #feffff;
        border: solid #0008 1px;
    }

    .control:hover input:not([disabled]):checked ~ .control_indicator,
    .control input:checked:focus ~ .control_indicator {
        background: #fdfbfb;
        border: solid #0008 1px;
    }

    .control input:disabled ~ .control_indicator {
        background: #e6e6e6;
        opacity: 0.6;
        pointer-events: none;
    }

    .control_indicator:after {
        box-sizing: unset;
        content: '';
        position: absolute;
        display: block;
        opacity: 0;
        transition: 0.1s;
        transform: rotate(45deg) scale(0);
    }

    .control input:checked ~ .control_indicator:after {
        opacity: 1;
        transform: rotate(45deg) scale(0.8);
    }

    .control-checkbox .control_indicator:after {
        left: 4px;
        top: 0px;
        width: 5px;
        height: 9px;
        border: solid #0b0b0b;
        border-width: 0 2px 2px 0;
    }

    .control-checkbox input:disabled ~ .control_indicator:after {
        border-color: #7b7b7b;
    }
`


export const statusHistoryCSS = css`
    .status-history {
        font-family: "Roboto";
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        color: black;
        padding: 20px;
        box-sizing: border-box;
        gap: 10px;
    }

    .status-history .title {
        font-family: "Roboto Bold";
        font-size: 17px;
    }

    .status-history .item-name {
        font-size: 13px;
        padding-bottom: 25px;
    }

    .status-history .item-name .bold {
        font-family: "Roboto Bold";
        color: black;
    }

    .status-history .entry {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        border: solid #0001 1px;
        background: white;
        background: white;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
        align-items: center;
    }

    .status-history .entry > * {
        display: flex;
        align-items: center;
        padding: 0px 10px;
        height: 45px;
        border-right: solid #0001 1px
    }

    .status-history .entry .agent {
        font-family: "Roboto Medium";
        flex-direction: column;
        justify-content: center;
        gap: 3px;
    }

    .status-history .entry .date {
        justify-content: center;
        font-family: "Roboto Bold"
    }

    .status-history .entry .status {
        display: grid;
        grid-template-columns: 20px 1fr;
        padding-left: 0px;
    }

    .status-history .status .color {
        display: flex;
        height: 100%;
        width: 100%;
    }

    .status-history .status .name {
        padding-left: 10px;
    }

`